export default __webpack_public_path__ + "static/media/html5.4a7dc936.png";